module.exports = __webpack_public_path__ + "static/media/3 lettering gothic calligraphy blackwork.1280x1707.dca7803f.webp";